import { Dispatch } from 'redux'

import { SelectOptionLocal } from '../../../types/common/commonTypes'
import { apiInstance } from '../../api/apiInstance'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAllOilsASTM =
    (searchTerm: string, typeId?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsASTM', value: true } })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/dicts/avito/OilsASTM', { typeId })
            const oilsASTM: SelectOptionLocal[] = []

            if (status === 'ok') {
                const parser = new DOMParser()
                const xmlDoc = parser.parseFromString(data, 'text/xml')
                const ASTMsNodes = xmlDoc.getElementsByTagName('ASTM')

                for (let i = 0; i < ASTMsNodes.length; i++) {
                    const ASTMName = ASTMsNodes[i].textContent?.trim()
                    if (ASTMName && ASTMName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        oilsASTM.push({ name: ASTMName, value: ASTMName })
                    }
                }
            }
            dispatch({ type: storeDispatchTypes.setAllOilsASTM, value: { oilsASTM } })
        } catch (e) {
            console.error('load ASTM failed', e)
        }

        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsASTM', value: false } })
    }

export default getAllOilsASTM
